<template>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="content">
            <div class="box info-box">
              <div class="box-header with-border">
                API Tesing
              </div>
              <div class="box-body">
                <div class="row">
                    
                  <div class="col-md-6">
                    <form @submit.prevent="sendApiRequest()">
                    <div class="input-group margin">
                        <div class="input-group-btn" style="width:100px;">
                            <select
                            v-model="apimethod"
                            name="apimethod"
                            class="form-control"
                            required
                          >
                            <option v-if="!form.apimethod" selected value="">
                              Method
                            </option>
                            <option value="get">GET</option>
                            <option value="post">POST</option>
                            <option value="delete">DELETE</option>
                            <option value="put">PUT</option>
                            <option value="patch">PATCH</option>
                          </select>
                        </div>
                        <!-- /btn-group -->
                        <input type="text" class="form-control" v-model="apiurl" name="apiurl" placeholder="Enter API URL" required>
                        <div class="input-group-btn">
                            <button type="submit" class="btn btn-default"><i class="fa fa-paper-plane"></i></button>
                        </div>
                    </div>
                    
                    
                    <div class="form-group margin">
                        <label>Param <span class="red">*</span></label><br>
                            
                        <span v-for="(input,k) in form.param_details" :key="k" style="display: flex; flex-flow: row wrap;
                            align-items: center;">
                            <input
                                v-model="input.apikey"
                                type="text"
                                name="apikey"
                                style="width:42% "
                                class="form-control"
                                placeholder="Key"
                                :class="{
                                'is-invalid': form.errors.has('apikey'),
                                }"
                            />
                            <has-error
                                :form="form"
                                field="apikey"
                            ></has-error>
                              
                            <input
                                v-model="input.apivalue"
                                type="text"
                                name="apivalue"
                                class="form-control"
                                style="width:42%"
                                placeholder="Value"
                                :class="{
                                'is-invalid': form.errors.has('apivalue'),
                                }"
                            />
                            <has-error
                                :form="form"
                                field="apivalue"
                            ></has-error>
                            &nbsp;
                            <span>
                            <i class="fa fa-minus-circle btn-danger" @click.once="remove(k)" v-show="k || ( !k && form.param_details.length > 1)"></i>
                            <i class="fa fa-plus-circle btn-success" @click.once="add(k)" v-show="k == form.param_details.length-1"></i>
                            </span>
                        </span>
                                
                            
                    </div>
                    
                    </form>
                  </div>
                  
                </div>
              </div>
            </div>
      
          </section>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'apitesting',
    data () {
      return {
        apimethod: '',
        apiurl: '',
        form: new Form({
          param_details: [
            {
              apikey: '',
              apivalue: ''
            }
          ]
        }),
        data: {}
      }
    },
    methods: {
      canAccess (perm) {
        return this.$store.state.permissions.includes(perm)
      },
      add (index) {
        this.form.param_details.push({apikey: '', apivalue: ''})
      },
      remove (index) {
        this.form.param_details.splice(index, 1)
      },
      sendApiRequest () {
        this.$axios({
          method: this.apimethod,
          url: this.apiurl,
          data: null
        })
        // this.$axios
        //   .get('checksms?mobile=' + this.form.mobile + '&smsTemplate=' + this.form.smsTemplate, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        //   .then((response) => response.data)
        //   .then((data) => {
        //     this.data = data
        //     // Toast.fire({
        //     //   icon: 'success',
        //     //   title: 'Branch Center Added Successfully'
        //     // })
        //   })
        //   .catch(
        //     function (error) {
        //       Toast.fire({ icon: 'error', title: error.response.data.error })
        //       this.form.errors.errors = error.response.data.error
        //     }.bind(this)
        //   )
      },
      checkSMS () {
        this.$axios
          .get('checksms?mobile=' + this.form.mobile + '&smsTemplate=' + this.form.smsTemplate, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.data = data
            // Toast.fire({
            //   icon: 'success',
            //   title: 'Branch Center Added Successfully'
            // })
          })
          .catch(
            function (error) {
              Toast.fire({ icon: 'error', title: error.response.data.error })
              this.form.errors.errors = error.response.data.error
            }.bind(this)
          )
      }
    }
  }
  </script>
  <style scoped>
  .red {
    color: red;
  }
  .content {
    padding: 0px;
  }
  .info-box {
      border-radius:10px;
      box-shadow: 0px 0px 4px gray;
    }
    .box-footer {
      border-radius:0px 0px 10px 10px;
    }
</style>



// WEBPACK FOOTER //
// ApiTesting.vue?34b9aa6b